import { ChatUserAvatarProps } from './types';

export const ChatUserAvatar = ({ children }: ChatUserAvatarProps) => <div className="relative size-10 flex-none rounded-lg bg-main-gradient">{children}</div>;
